import { createFileRoute } from '@tanstack/react-router'
import type { IntegrationConnectorCategory } from '@/gql/graphql'

const categories = new Set<IntegrationConnectorCategory>([
  'ACCOUNTING',
  'PAYMENTS',
  'CRM',
  'BANKING',
  'HRIS',
  'TIME_TRACKING',
  'EXPENSE',
])

interface IntegrationsSearch {
  q?: string
  view?: 'all' | 'mine' | IntegrationConnectorCategory
}

export const Route = createFileRoute('/integrations/')({
  validateSearch: (search: Record<string, unknown>): IntegrationsSearch => ({
    q:
      typeof search.q === 'string' && search.q.trim()
        ? search.q.trim()
        : undefined,
    view:
      search.view === 'all' ||
      search.view === 'mine' ||
      categories.has(search.view as IntegrationConnectorCategory)
        ? (search.view as 'all' | 'mine' | IntegrationConnectorCategory)
        : undefined,
  }),
})
